import { usePackages } from '../../orderSlice';

export function PackageName({ id }: { id?: number }) {
  const items = usePackages();
  const item = items.find((x) => x.packageId === id);
  return <>{item ? item.name : ''}</>;
}
